export function invokeRegisteredCallbacks(mosaic, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
data) {
    var _a;
    // pull out the provider id and log type so the user can filter on them
    const providerId = data.provider;
    const eventType = data.logType;
    (_a = mosaic === null || mosaic === void 0 ? void 0 : mosaic.loggingCallbacks) === null || _a === void 0 ? void 0 : _a.forEach((callback) => {
        try {
            callback({ eventType, providerId, data });
        }
        catch (e) { }
    });
}
